import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function FloatingCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-6 right-5 z-50 flex flex-col items-end gap-2.5"
      style={{ animation: 'fadeInUp 0.35s ease-out both' }}
    >
      {/* Book Quote button */}
      <Link
        to="/contact"
        className="flex items-center gap-2 bg-brand-dark hover:bg-brand-light text-white text-sm font-bold py-3 px-5 rounded-full border border-white/10 transition-all duration-200 cursor-pointer whitespace-nowrap"
        aria-label="Get a Free Quote"
      >
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-calendar-check-fill text-brand-amber" />
        </div>
        Free Quote
      </Link>

      {/* Call Now button — primary */}
      <a
        href="tel:+19045550191"
        className="flex items-center gap-2 bg-brand-amber hover:bg-brand-amber-dark text-white font-bold py-3.5 px-6 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap animate-float"
        aria-label="Call BBM Services"
      >
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-phone-fill" />
        </div>
        <span className="text-sm">(904) 555-0191</span>
      </a>
    </div>
  );
}
